<template lang="pug">
  #app
    router-view  
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import "./scss/main.scss"
</style>